import React from "react";
import styles from "./Stepper.module.scss";
import { sanitizeHtmlDecoded, stripTags } from '../../../../../Utils/sanitize';

const Stepper = ({ steps, activeStep, onStepClick }) => {
  return (
    <div className={styles.stepper}>
      {steps.map((step, index) => (
        <div
          key={index}
          className={`${styles.step} ${
            index === activeStep ? styles.active : ""
          }`}
          onClick={() => onStepClick(index)}
        >
          <div className={styles.stepTitle}>{index + 1}. {stripTags(step.stepTitle)}</div>
          {index === activeStep && (
            <div
              className={styles.stepDescription}
              dangerouslySetInnerHTML={{ __html: sanitizeHtmlDecoded(step.stepDescription.html) }}
            />
          )}
        </div>
      ))}
    </div>
  );
};

export default Stepper;